import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private translationService = inject(TranslationService);

  transform(value: string): string {
    if (!value) return '';

    const keyword = value.toLowerCase().trim().split(' ').join('-').replace(/--/g, '-');

    return this.translationService.translate(keyword);
  }
}
